module.exports = __webpack_public_path__ + "static/media/7689335a082e02b.6fcc50f6.mp3";